// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.harvest_operation_event_type_enum */
var HarvestOperationEventTypeEnum;
(function (HarvestOperationEventTypeEnum) {
    HarvestOperationEventTypeEnum["OBSERVATION"] = "OBSERVATION";
    HarvestOperationEventTypeEnum["STATUS_CHANGE"] = "STATUS_CHANGE";
})(HarvestOperationEventTypeEnum || (HarvestOperationEventTypeEnum = {}));
;
export default HarvestOperationEventTypeEnum;
/** Zod schema for harvest_operation_event_type_enum */
export const harvestOperationEventTypeEnum = z.nativeEnum(HarvestOperationEventTypeEnum);
//# sourceMappingURL=HarvestOperationEventTypeEnum.js.map